module.exports = __webpack_public_path__ + "img/single-vel-info.1c627a59.png";